import { DetailListFilter } from './DetailListFilter'

const DetailListToolbar = () => {
  return (
    <div className='d-flex justify-content-end' data-kt-user-table-toolbar='base'>
      <DetailListFilter />
    </div>
  )
}

export {DetailListToolbar}
